/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface PutContactShareDocumentVerifyMaterialContactableResponse
 */
export interface PutContactShareDocumentVerifyMaterialContactableResponse {
  /**
   *
   * @type {number}
   * @memberof PutContactShareDocumentVerifyMaterialContactableResponse
   */
  status?: number
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof PutContactShareDocumentVerifyMaterialContactableResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function PutContactShareDocumentVerifyMaterialContactableResponseFromJSON(
  json: any
): PutContactShareDocumentVerifyMaterialContactableResponse {
  return PutContactShareDocumentVerifyMaterialContactableResponseFromJSONTyped(json, false)
}

export function PutContactShareDocumentVerifyMaterialContactableResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutContactShareDocumentVerifyMaterialContactableResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function PutContactShareDocumentVerifyMaterialContactableResponseToJSON(
  value?: PutContactShareDocumentVerifyMaterialContactableResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
